import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalUserTypeService {
  /**
   * The hide variable is declare
   * @param hide Variable to hide the modal
   */
  public hide = 'hide';
  /**
   * The notification variable is declare
   * @param notification Variable to send notifications
   */
  public notification = new EventEmitter<any>();

  /**
   * @ignore
   */
  constructor() {}

  /**
   * Function that allows to hide the modal
   */
  hideModal() {
    this.hide = 'hide';
    return 'hide';
  }

  /**
   * Function that allows to show the modal
   */
  showModal() {
    this.hide = '';
    return '';
  }
}
